import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class PrintService {
    private isPdfPrintingNotInProgress = new BehaviorSubject(true);

    public isPdfPrintingNotInProgress$ = this.isPdfPrintingNotInProgress.asObservable();

    /* Methods */
    public emitPdfPrintingNotInProgress(state: boolean): void {
        this.isPdfPrintingNotInProgress.next(state);
    }
}
